<template>
	<div>
		<q-card
			class="full-height shadow-transition relative-position cursor-pointer card-bottom-line"
			v-if="!$q.platform.is.mobile"
			:class="class_hover"
			@mouseover="class_hover = 'shadow-5'"
			@mouseleave="class_hover = ''"
			@click="answerDrill()"
		>
			<q-card-section class="q-mb-lg">
				<div class="row">
					<div class="col-12 text-weight-bold text-h6 title">
						{{ drill.title }}
					</div>

					<div class="col-12 q-mt-md text-grey-6 description">
						{{ description(drill.description) }}
					</div>
				</div>
			</q-card-section>
			<q-card-actions class="text-grey-5 absolute-bottom">
				<div class="row full-width q-col-gutter-">
					<div class="col-12 text-center">
						<q-badge color="white" text-color="black">
							<q-icon name="fal fa-trophy" color="black" size="15px" />
							<span class="q-ml-sm"
								>{{ drill.score }} {{ $t('point', { count: drill.score }) }}</span
							>
						</q-badge>

						<q-badge color="white" text-color="black">
							<q-icon name="fal fa-question-square" color="black" size="15px" />
							<span class="q-ml-sm">{{ drill.drill_questions.length }}</span>
						</q-badge>
					</div>
				</div>
			</q-card-actions>
		</q-card>
		<q-card
			v-if="$q.platform.is.mobile"
			class="bg-grey-9 card-empty"
			dark
			:class="class_hover"
			@click="answerDrill()"
		>
			<q-card-section>
				<div class="text-body1">
					{{ drill.title }}
				</div>

				<div class="col-12 q-mt-md text-grey-6 text-subtitle2">
					{{ description(drill.description) }}
				</div>
			</q-card-section>
			<q-card-actions class="text-grey-5 absolute-bottom">
				<div class="row full-width q-col-gutter-">
					<div class="col-12 text-center">
						<q-badge color="grey-9" text-color="white">
							<q-icon name="fal fa-trophy" color="white" size="15px" />
							<span class="q-ml-sm"
								>{{ drill.score }} {{ $t('point', { count: drill.score }) }}</span
							>
						</q-badge>

						<q-badge color="grey-9" text-color="white">
							<q-icon name="fal fa-question-square" color="white" size="15px" />
							<span class="q-ml-sm">{{ drill.drill_questions.length }}</span>
						</q-badge>
					</div>
				</div>
			</q-card-actions>
		</q-card>
	</div>
</template>

<script>
export default {
	name: 'DrillCard',

	props: ['drill'],

	data() {
		return {
			hover: false,
			class_hover: '',
		}
	},

	methods: {
		description(e) {
			var regex = /(<([^>]+)>)/gi
			var body = '<p>test</p>'
			var result = body.replace(regex, '')
			if (e) return e.replace(regex, '')
		},

		answerDrill() {
			this.$emit('open_drill', this.drill.id)
		},
	},
}
</script>

<style lang="scss" scoped>
.title {
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
	line-height: 2rem;
	margin-bottom: 0;
	height: 40px;
}
.description {
	display: -webkit-box;
	-webkit-line-clamp: 4;
	-webkit-box-orient: vertical;
	overflow: hidden;
	margin-bottom: 25px;
}
</style>
